import { render } from "./DetailReservationModal.vue?vue&type=template&id=21ae97c8&scoped=true&ts=true"
import script from "./DetailReservationModal.vue?vue&type=script&lang=ts"
export * from "./DetailReservationModal.vue?vue&type=script&lang=ts"

import "./DetailReservationModal.vue?vue&type=style&index=0&id=21ae97c8&scoped=true&lang=scss"

import exportComponent from "D:\\Proyectos\\mytransfers-extranet-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21ae97c8"]])

export default __exports__